// Ng doesn't recommend "barrel" imports anymore
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';

//
import { LoadSpinnerComponent } from './components/load-spinner/load-spinner.component';
import { BaseModalComponent } from './components/modal-components/base-modal/base-modal.component';
import { ModalShellComponent } from './components/modal-components/modal-shell/modal-shell.component';
import { ModalHeaderComponent } from './components/modal-components/modal-header/modal-header.component';
import { ModalBodyComponent } from './components/modal-components/modal-body/modal-body.component';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { HamburgerMenuComponent } from './components/hamburger-menu/hamburger-menu.component';

// form
import { AutofocusInputGroupComponent } from './components/form-components/autofocus-input-group/autofocus-input-group.component';
import { SelectComponent } from './components/form-components/select/select.component';
import { CheckboxComponent } from './components/form-components/checkbox/checkbox.component';
import { InputGroupComponent } from './components/form-components/input-group/input-group.component';
import { InputRequirementsListComponent } from './components/form-components/input-requirements-list/input-requirements-list.component';
import { TextareaComponent } from './components/form-components/textarea/textarea.component';
import { LabelComponent } from './components/form-components/label/label.component';
import { RequiredAsteriskComponent } from './components/form-components/required-asterisk/required-asterisk.component';
import { RequiredMessageComponent } from './components/form-components/required-message/required-message.component';
//
import { NavMobileComponent } from './components/nav-mobile/nav-mobile.component'
import { PersonaModalComponent } from './components/persona-modal/persona-modal.component';
import { ConfirmationModalComponent } from './components/modal-components/confirmation-modal/confirmation-modal.component';
import { ModalFooterComponent } from './components/modal-components/modal-footer/modal-footer.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { TableCellComponent } from './components/tables/table-cell/table-cell.component';
import { TableHeaderComponent } from './components/tables/table-header/table-header.component';
import { TableComponent } from './components/tables/table/table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SponsorComponent } from './components/sponsor/sponsor.component';
import { HeaderComponent } from './components/header/header.component';
import { NavComponent } from './components/nav/nav.component';
import { FooterComponent } from './components/footer/footer.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { ShellComponent } from './components/shell/shell.component';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { DividerComponent } from './components/divider/divider.component';
import { UnderlinedHeadingComponent } from './components/underlined-heading/underlined-heading.component';
import { ButtonComponent } from './components/button/button.component';
import { TagComponent } from './components/tag/tag.component';
import { PersonaComponent } from './components/persona/persona.component';
import { SessionComponent } from './components/session/session.component';
import { PersonaShortComponent } from './components/persona-short/persona-short.component';
import { HRComponent } from './components/hr/hr.component';
import { AccordionButtonComponent } from './components/accordion-button/accordion-button.component';

// SVG
import { LogoComponent } from './components/svg-components/logo/logo.component';
import { LinkedinComponent } from './components/svg-components/linkedin/linkedin.component';
import { EmailComponent } from './components/svg-components/email/email.component';
import { GithubComponent } from './components/svg-components/github/github.component';
import { TwitterComponent } from './components/svg-components/twitter/twitter.component';
import { FacebookComponent } from './components/svg-components/facebook/facebook.component';
import { WebsiteComponent } from './components/svg-components/website/website.component';
import { TriangleComponent } from './components/svg-components/triangle/triangle.component';
import { SocialLinksComponent } from './components/social-links/social-links.component';
import { SpeakerComponent } from './components/speaker/speaker.component';
import { CalloutSocialComponent } from './components/callout-social/callout-social.component';
import { CalloutSignupComponent } from './components/callout-signup/callout-signup.component';
import { RegisterButtonComponent } from './components/register-button/register-button.component';
import { AttendeesBannerComponent } from './components/attendees-banner/attendees-banner.component';
import { SponsorshipDocLinkComponent } from './components/sponsorship-doc-link/sponsorship-doc-link.component';
import { MastodonComponent } from './components/svg-components/mastodon/mastodon.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [
    SponsorshipDocLinkComponent,
    AttendeesBannerComponent,
    RegisterButtonComponent,
    CalloutSignupComponent,
    CalloutSocialComponent,
    SpeakerComponent,
    SocialLinksComponent,
    NavMobileComponent,
    HamburgerMenuComponent,
    PersonaModalComponent,
    RequiredMessageComponent,
    RequiredAsteriskComponent,
    LabelComponent,
    TextareaComponent,
    SelectComponent,
    TriangleComponent,
    AccordionButtonComponent,
    HRComponent,
    WebsiteComponent,
    FacebookComponent,
    TwitterComponent,
    GithubComponent,
    EmailComponent,
    LinkedinComponent,
    MastodonComponent,
    LogoComponent,
    PersonaShortComponent,
    SessionComponent,
    SponsorComponent,
    PersonaComponent,
    TagComponent,
    ButtonComponent,
    UnderlinedHeadingComponent,
    DividerComponent,
    ShellComponent,
    PageTitleComponent,
    NavComponent,
    HeaderComponent,
    FooterComponent,
    ConfirmModalComponent,
    LoadSpinnerComponent,
    BaseModalComponent,
    ModalShellComponent,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    InputGroupComponent,
    TableComponent,
    CheckboxComponent,
    SearchBarComponent,
    InputRequirementsListComponent,
    ErrorMessageComponent,
    AutofocusInputGroupComponent,
    ConfirmationModalComponent,
    TableHeaderComponent,
    TableCellComponent
  ],
  exports: [
    SponsorshipDocLinkComponent,
    AttendeesBannerComponent,
    RegisterButtonComponent,
    CalloutSignupComponent,
    CalloutSocialComponent,
    SpeakerComponent,
    SocialLinksComponent,
    NavMobileComponent,
    HamburgerMenuComponent,
    PersonaModalComponent,
    RequiredMessageComponent,
    RequiredAsteriskComponent,
    LabelComponent,
    TextareaComponent,
    SelectComponent,
    TriangleComponent,
    AccordionButtonComponent,
    HRComponent,
    WebsiteComponent,
    FacebookComponent,
    TwitterComponent,
    GithubComponent,
    EmailComponent,
    LinkedinComponent,
    MastodonComponent,
    LogoComponent,
    PersonaShortComponent,
    SessionComponent,
    SponsorComponent,
    PersonaComponent,
    TagComponent,
    ButtonComponent,
    UnderlinedHeadingComponent,
    DividerComponent,
    ShellComponent,
    PageTitleComponent,
    NavComponent,
    HeaderComponent,
    FooterComponent,
    ConfirmModalComponent,
    LoadSpinnerComponent,
    BaseModalComponent,
    ModalShellComponent,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    InputGroupComponent,
    TableComponent,
    CheckboxComponent,
    SearchBarComponent,
    InputRequirementsListComponent,
    ErrorMessageComponent,
    AutofocusInputGroupComponent,
    ConfirmationModalComponent,
    TableHeaderComponent,
    TableCellComponent
  ]
})
export class LayoutModule { }
